module.exports = __webpack_public_path__ + "img/icon-03---Copy.7186026f.png";